import { MenuItem, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import type { RegistryApi } from '../../api/registryApi';
import type { RegistryStaffMember } from '../../api/registryApiTypes';

interface Props {
  api: Pick<RegistryApi, 'listStaff'>;
  email: string;
  disabled: boolean;
  /** Makes the chosen staff member the account contact (the server fills in their details). */
  choose: (staffExternalId: string) => void;
}

/** Fills the account contact from a colleague's staff profile. */
export default function StaffContactPicker({ api, email, disabled, choose }: Props) {
  const [staff, setStaff] = useState<RegistryStaffMember[]>([]);
  useEffect(() => {
    let active = true;
    api
      .listStaff()
      .then((list) => active && setStaff(list))
      .catch(() => undefined);
    return () => {
      active = false;
    };
  }, [api]);
  const selected = staff.find((member) => member.email === email)?.externalId ?? '';
  if (!staff.length) return null;
  return (
    <TextField
      select
      fullWidth
      size="small"
      label="Account contact"
      helperText="Choose another staff member to fill in the contact details below."
      value={selected}
      disabled={disabled}
      onChange={(event) => {
        if (event.target.value) choose(event.target.value);
      }}
      sx={{ gridColumn: '1 / -1' }}
    >
      {staff.map((member) => (
        <MenuItem key={member.externalId} value={member.externalId}>
          {member.name}
          {member.jobTitle ? ` — ${member.jobTitle}` : ''}
        </MenuItem>
      ))}
    </TextField>
  );
}
